<template>
  <div style="text-align: right; margin-top: 6px">
    <el-pagination
      :background="background"
      :layout="layout"
      :page-size="pageSize"
      small
      :total="total"
      @current-change="pageChange"
      :current-page.sync="myCurrentPage"
    >
    </el-pagination>
  </div>
</template>
<script>
export default {
  props: {
    layout: {
      type: String,
      default: "total,prev,pager,next",
    },
    currentPage: {
      type: Number,
      default: 1,
    },
    total: {
      type: Number,
      default: 0,
    },
    pageSize: {
      type: Number,
      default: 10,
    },
    background: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      myCurrentPage: 1,
    };
  },
  watch: {
    currentPage() {
      this.myCurrentPage = this.currentPage;
    },
  },
  methods: {
    pageChange(val) {
      this.$emit("current-change", val);
    },
  },
};
</script>
